import React from "react";
import ReactDOMServer from "react-dom/server";

export const getVacancyContractAdditionalTenantAddressAddressHtml = (tenantIndex: number) => {
  return ReactDOMServer.renderToString(
    <VacancyContractAdditionalTenantAddress tenantIndex={tenantIndex} />
  );
};

type Props = {
  tenantIndex: number;
};

const VacancyContractAdditionalTenantAddress = (props: Props) => {
  const { tenantIndex } = props;

  return (
    <>
      <br></br>
      <br></br>
      <p style={{ display: "flex", alignItems: "center" }}>
        <span
          className="mention-variable"
          data-variable-id={`applicantFirstName-${tenantIndex}`}        >
          $Vacancy-Applicant-FirstName-{tenantIndex}
        </span>
        &nbsp;
        <span className="mention-variable" data-variable-id={`applicantLastName-${tenantIndex}`}>
          $Vacancy-Applicant-LastName-{tenantIndex}
        </span>
        <span style={{ marginLeft: "auto" }}>-Mieter-</span>
      </p>
      <p>
        <span className="mention-variable" data-variable-id={`applicantStreet-${tenantIndex}`}>
          $Vacancy-Applicant-Street-{tenantIndex}
        </span>
        &nbsp;
        <span
          className="mention-variable"
          data-variable-id={`applicantStreetNumber-${tenantIndex}`}
        >
          $Vacancy-Applicant-StreetNumber-{tenantIndex}
        </span>
      </p>
      <p>
        <span className="mention-variable" data-variable-id={`applicantZip-${tenantIndex}`}>
          $Vacancy-Applicant-ZIP-{tenantIndex}
        </span>
        &nbsp;
        <span className="mention-variable" data-variable-id={`applicantCity-${tenantIndex}`}>
          $Vacancy-Applicant-City-{tenantIndex}
        </span>
      </p>
    </>
  );
};

export default VacancyContractAdditionalTenantAddress;
